import React from 'react'

import styled from '@emotion/styled'
import { text, black03, grayBorder, mq } from '../../../_style'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 82px;
  margin: 10px 0 0 10px;
  padding: 10px 1px;
  border: 1px solid ${grayBorder};
  text-align: center;
  & > span {
    color: ${black03};
    ${text('12px', 18 / 12)}
  }
  ${mq.sp} {
    width: calc(33.3% - 6.66px);
    height: 52px;
    &:nth-of-type(4n) {
      border-left: 1px solid ${grayBorder};
    }
  }
`
export default class Category extends React.Component {
  render() {
    return(
      <Container>
        <span>{this.props.children}</span>
      </Container>
    )
  }
}
